import { get } from "lodash";

export interface OnboardingCompletionStatus {
  isComplete: boolean;
  completedTasks: {
    organization: boolean;
    domain: boolean;
    payment: boolean;
    branding: boolean;
  };
}

export const checkOnboardingCompletion = (
  charityId: string,
  firebaseData: any
): OnboardingCompletionStatus => {
  if (!charityId || !firebaseData || !firebaseData[charityId]) {
    return {
      isComplete: false,
      completedTasks: {
        organization: false,
        domain: false,
        payment: false,
        branding: false,
      },
    };
  }

  const charityData = firebaseData[charityId];

  const organizationData = get(charityData, "charitySetup.organization");
  const organizationComplete = organizationData?.status === "completed";

  const emailSetup = get(charityData, "charitySetup.email");
  const domainComplete = emailSetup?.hasVerifiedDomain === true;

  const accountType = get(charityData, "config.stripe.accountType");
  const paymentComplete = accountType === "connected";

  const brandSetupData = get(charityData, "charitySetup.brandSetup");
  const brandingComplete =
    brandSetupData?.status === "completed" ||
    brandSetupData?.progressTracker === "published";

  const completedTasks = {
    organization: organizationComplete,
    domain: domainComplete,
    payment: paymentComplete,
    branding: brandingComplete,
  };

  const isComplete = Object.values(completedTasks).every(task => task === true);

  return {
    isComplete,
    completedTasks,
  };
};

export const isOnboardingRequired = (
  charityId: string,
  firebaseData: any
): boolean => {
  return get(firebaseData, `${charityId}.onboardingRequired`) === true;
};

export const isOnboardingComplete = (
  charityId: string,
  firebaseData: any
): boolean => {
  if (!isOnboardingRequired(charityId, firebaseData)) {
    return true;
  }
  return checkOnboardingCompletion(charityId, firebaseData).isComplete;
};